import { Link, useSearchParams } from 'react-router-dom';
import { getTranslation } from '../../constants/translations';
import { getRegion } from '../../helpers/getRegion';

import './Footer.scss';
import { ROUTES } from '../../constants/routes';
import { openLoginModal } from '../../helpers/openLoginModal';

export const Footer = () => {
  const root = document.getElementById('root');
  const domen = getRegion();
  const t = getTranslation();
  const [serchParams] = useSearchParams();
  const isToken = !!serchParams.get('token');

  if (root) {
    root.dataset.theme = domen;
  }

  let policyLink = '/';
  let termsLink = '/';
  let cookieLink = '/';

  if (domen === 'rs') {
    policyLink = ROUTES.POLICY;
    termsLink = ROUTES.TERMS;
  }

  if (domen === 'com') {
    policyLink = `https://sixtix.com/documents/SIXTIX_NL_Privacy_Policy_2025_EN_v24_07_25.pdf`;
    termsLink = `https://sixtix.com/documents/SIXTIX_NL_Terms_of_Service_2025_EN.pdf`;
  }

  if (domen === 'nl') {
    policyLink = `https://sixtix.nl/documents/SIXTIX_NL_Privacyverklaring_2025_NL_v24_07_25.pdf`;
    termsLink = `https://sixtix.nl/documents/SIXTIX_NL_Algemene_Voorwaarden_2025_NL.pdf`;
    cookieLink = `https://sixtix.nl/documents/SIXTIX_NL_Cookieverklaring_2025_NL.pdf`;
  }

  if (isToken) return null;

  return (
    <footer className="sixtix__footer footer">
      <div className="footer__container _container">
        <Link to="/">
          <img className="logo" src={`./${domen}/logo.png`} alt="SixTix" />
        </Link>

        <nav className="footer__nav">
          <button className="footer__link" onClick={openLoginModal}>
            {t.common.login}
          </button>
          <a className="footer__link" href={`mailto:info@sixtix.${domen}`}>
            {t.common.lostTicket}
          </a>
          <a className="footer__link" href={`mailto:info@sixtix.${domen}`}>
            {t.common.contact}
          </a>
        </nav>

        <div className="footer__legals-list">
          <Link to={policyLink} className="footer__legal-item">
            {t.common.policy}
          </Link>
          <Link to={termsLink} className="footer__legal-item">
            {t.common.terms}
          </Link>
          {domen === 'nl' && (
            <Link to={cookieLink} className="footer__legal-item">
              {t.common.cookie}
            </Link>
          )}
        </div>
      </div>
    </footer>
  );
};
